<template>
  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.organization_id"
             type="number"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.organization_id')">
      <label>{{ $t('payment_provider_accounts.organization_id') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.provider_key"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.provider_key')">
      <label>{{ $t('payment_provider_accounts.provider_key') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.name"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.name')">
      <label>{{ $t('payment_provider_accounts.name') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.status"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.status')">
      <label>{{ $t('payment_provider_accounts.status') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-6 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.api_key"
             type="password"
             autocomplete="new-password"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.api_key')">
      <label>{{ $t('payment_provider_accounts.api_key') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.profile_id"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.profile_id')">
      <label>{{ $t('payment_provider_accounts.profile_id') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-3 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.default_currency"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.default_currency')">
      <label>{{ $t('payment_provider_accounts.default_currency') }}</label>
    </div>
  </div>

  <div class="col-12 col-lg-6 mb-3">
    <div class="form-floating">
      <input v-model="localFormData.webhook_url"
             type="text"
             class="form-control"
             :placeholder="$t('payment_provider_accounts.webhook_url')">
      <label>{{ $t('payment_provider_accounts.webhook_url') }}</label>
    </div>
  </div>

</template>

<script>
export default {
  name: 'PaymentProviderAccountFormFields',
  props: {
    formData: {
      type: Object,
      required: true,
    }
  },
  emits: ['update:formData'],
  data() {
    return {
      localFormData: {...this.formData},
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(newValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(this.localFormData)) {
          this.localFormData = {...newValue}
        }
      }
    },
    localFormData: {
      deep: true,
      handler(newValue) {
        this.$emit('update:formData', {...newValue})
      }
    }
  }
}
</script>
